/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Modified By: rogerk
 * Created On: March 29th, 2018
 * Last Modified: March 29th, 2018
 * ****************************************************************************
 */
import * as React from 'react';
import { EventEmitter } from 'events';
import { PopupMenuItem } from 'components';

const { Provider, Consumer } = React.createContext<AppEvents>(null as any);

export const AppEventsContext = Consumer;
export const AppEventsContextProvider = Provider;

export class AppEvents {
  private readonly _events = new EventEmitter();
  private readonly _closures: any = {};

  menuClick(name: string) {

    if (!this._closures[name]) {
      this._closures[name] = () => {
        let handled = this._events.emit(`menu:${name}`);
        if (!handled) {
          handled = this._events.emit(`menu-default:${name}`);
        }
        if (!handled) {
          console.warn(`Menu ${name} not handled.`);
        }
      };
    }
    return this._closures[name];
  }

  onMenu(name: string, action: () => void): () => void {
    return this.onEvent(`menu:${name}`, action);
  }

  onMenuDefault(name: string, action: () => void): () => void {
    return this.onEvent(`menu-default:${name}`, action);
  }

  onEvent<TArg>(eventName: string, action: (arg: TArg) => void, filter?: (arg: TArg) => boolean): () => void {
    const subscriber = (arg: TArg) => {
      if ((!filter || filter(arg)) && action) { action(arg); }
    };
    this._events.on(eventName, subscriber);
    return () => { this._events.removeListener(eventName, subscriber); };
  }

  onBuildMenu(action: (menu: PopupMenuItem[]) => void) {
    return this.onEvent<PopupMenuItem[]>('build-menu', action);
  }

  buildMenu(): PopupMenuItem[] {
    const menuItems: PopupMenuItem[] = [];
    const handled = this._events.emit(`build-menu`, menuItems);
    if (!handled) {
      menuItems.push(
        { icon: 'add_box', text: 'New Game', action: this.menuClick('new-game') }
      );
    }
    return menuItems;
  }
}



// WEBPACK FOOTER //
// ./src/contexts/appEventsContext.tsx